(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("React.addons.shallowCompare"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "React.addons.shallowCompare", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["ReactVirtualized"] = factory(require("React"), require("React.addons.shallowCompare"), require("ReactDOM"));
	else
		root["ReactVirtualized"] = factory(root["React"], root["React.addons.shallowCompare"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_89__, __WEBPACK_EXTERNAL_MODULE_90__, __WEBPACK_EXTERNAL_MODULE_96__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/